import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 575, // custom
      md: 992, // custom
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    primary: {
      main: '#1a237e',
      light: '#534bae',
      dark: '#000051',
    },
    background: {
      default: '#ffffff',
      paper: 'var(--basic-bg)',
    },
  },
  typography: {
    fontFamily: '"Golos Text", sans-serif',
  },
  components: {
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontWeight: 500,
          fontFamily: '"Golos Text", sans-serif',
        },
        secondary: {
          fontFamily: '"Golos Text", sans-serif',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontFamily: '"Golos Text", sans-serif',
          color: 'var(--text-primary-color)',
        },
        head: {
          fontWeight: 400,
          fontFamily: '"Golos Text", sans-serif',
          color: 'var(--text-secondary-color)',
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          fontFamily: '"Golos Text", sans-serif',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: '0',
          backgroundColor: 'var(--basic-color)',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paperWidthXs: {
          maxWidth: '360px',
          borderRadius: '16px',
        },
        paperWidthLg: {
          maxWidth: '792px',
          borderRadius: '16px',
        },
        paperWidthMd: {
          maxWidth: '512px',
          borderRadius: '16px',
        },
        paperWidthXl: {
          maxWidth: '1280px',
          borderRadius: '16px',
        },
      },
    },
  },
});

export const rsuiteComponents = {
  Input: { defaultProps: { size: 'md' } },
  SelectPicker: {
    defaultProps: {
      size: 'md',
      appearance: 'subtle',
      block: true,
      listboxMaxHeight: 180,
      preventOverflow: true,
    },
  },
};
